// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface RESTLicenseOverviewOptions
 */
export interface RESTLicenseOverviewOptions {
    /**
     * Specifies date and time when the reporting interval starts.
     * @type {string}
     * @memberof RESTLicenseOverviewOptions
     */
    startTime?: string;
    /**
     * Specifies date and time when the reporting interval ends.
     * @type {string}
     * @memberof RESTLicenseOverviewOptions
     */
    endTime?: string;
    /**
     * Specifies the format in which to save a report.
     * @type {string}
     * @memberof RESTLicenseOverviewOptions
     */
    format?: RESTLicenseOverviewOptionsFormatEnum;
    /**
     * Specifies a time zone for the reporting interval. If you do not specify this property, the server will generate a report for the UTC time zone.
     * @type {string}
     * @memberof RESTLicenseOverviewOptions
     */
    timezone?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTLicenseOverviewOptionsFormatEnum {
    Pdf = 'PDF',
    Csv = 'CSV'
}

